module.exports = __webpack_public_path__ + "static/media/Barnas_Skog_3.fa8bc8fe.pdf";